import { graphql } from "~/gql";

export const UPDATE_BRAND = graphql(/* GraphQL */ `
  mutation updateBrand($data: UpdateBrandInput!) {
    updateBrand(data: $data) {
      ...BrandParts
    }
  }
`);
